import React from "react";
import SEO from "../components/SEO";

const Refund = () => {
  return (
    <>
      <SEO
        title='Refund'
        description='Patch Designers For Hats'
        keywords='Patch Designers For Hats'
      />
      <div className="relative bg-gradient-to-br from-[#f1f7f5] via-white to-[#ecf3f1] overflow-hidden">

        {/* Decorative background */}
        <div className="absolute -top-40 -right-40 w-96 h-96 bg-[#437d6a]/20 rounded-full blur-3xl" />
        <div className="absolute -bottom-40 -left-40 w-96 h-96 bg-[#437d6a]/10 rounded-full blur-3xl" />

        <div className="relative container mx-auto px-4 py-24 max-w-6xl">

          {/* Header */}
          <div className="text-center mb-24">
            <div className="inline-flex items-center gap-2 px-6 py-3 rounded-full bg-white/70 backdrop-blur border border-[#437d6a]/20 text-[#437d6a] font-semibold shadow-sm">
              Refunds & Returns
            </div>

            <h1 className="mt-8 text-4xl md:text-6xl font-extrabold text-gray-900 tracking-tight">
              Refund & Return Policy
            </h1>

            <p className="mt-8 max-w-3xl mx-auto text-lg text-gray-600 leading-relaxed">
              Please review our refund and return guidelines for custom orders
              placed with{" "}
              <span className="font-semibold text-[#437d6a]">
                Personalised Hat Patches
              </span>.
            </p>
          </div>

          {/* Glass Card */}
          <div className="bg-white/80 backdrop-blur-xl rounded-[32px] shadow-2xl border border-gray-200 p-10 md:p-16 space-y-20">

            {/* Intro */}
            <p className="text-xl text-gray-700 leading-relaxed">
              At{" "}
              <span className="font-semibold text-gray-900">
                Personalised Hat Patches
              </span>
              , all products are custom-made according to customer specifications.
              Due to the personalized nature of our items, returns are not
              accepted. However, your satisfaction matters to us, and we are
              committed to resolving any issues fairly.
            </p>

            {/* Sections */}
            {[
              {
                icon: "",
                title: "No Returns on Customized Products",
                body: (
                  <p>
                    Once an order is approved and production has begun, returns or
                    exchanges are not possible.
                  </p>
                ),
              },
              {
                icon: "",
                title: "Eligible Refunds & Replacements",
                body: (
                  <>
                    <p>Refunds or replacements may be considered if:</p>
                    <ul className="grid sm:grid-cols-2 gap-3 mt-3">
                      <li className="bg-[#f1f7f5] rounded-xl px-4 py-2">
                        ❌ Incorrect product received
                      </li>
                      <li className="bg-[#f1f7f5] rounded-xl px-4 py-2">
                        🧵 Manufacturing defects
                      </li>
                      <li className="bg-[#f1f7f5] rounded-xl px-4 py-2">
                        🎨 Artwork mismatch
                      </li>
                      <li className="bg-[#f1f7f5] rounded-xl px-4 py-2">
                        📦 Shipping damage
                      </li>
                    </ul>
                    <p className="mt-3">
                      Supporting photos or videos may be required.
                    </p>
                  </>
                ),
              },
              {
                icon: "",
                title: "Reporting an Order Issue",
                body: (
                  <p>
                    Issues must be reported within{" "}
                    <span className="font-semibold text-[#437d6a]">
                      45 days of delivery
                    </span>
                    . Requests submitted after this period may not be eligible.
                  </p>
                ),
              },
              {
                icon: "",
                title: "Resolution Process",
                body: (
                  <>
                    <p>
                      Our support team reviews requests within{" "}
                      <span className="font-semibold text-[#437d6a]">
                        one business day
                      </span>
                      .
                    </p>
                    <p>
                      Depending on the situation, we may offer a replacement,
                      partial refund, or store credit.
                    </p>
                  </>
                ),
              },
              {
                icon: "",
                title: "Non-Refundable Situations",
                body: (
                  <ul className="grid sm:grid-cols-2 gap-3">
                    <li className="bg-[#f1f7f5] rounded-xl px-4 py-2">
                      🔄 Change of mind after approval
                    </li>
                    <li className="bg-[#f1f7f5] rounded-xl px-4 py-2">
                      🚚 Courier or customs delays
                    </li>
                    <li className="bg-[#f1f7f5] rounded-xl px-4 py-2">
                      ✋ Minor handmade variations
                    </li>
                    <li className="bg-[#f1f7f5] rounded-xl px-4 py-2">
                      📍 Incorrect shipping address
                    </li>
                  </ul>
                ),
              },
            ].map((item, index) => (
              <section
                key={index}
                className="relative pl-10 border-l-4 border-[#437d6a] space-y-4"
              >
                <h2 className="text-2xl font-bold text-gray-900 flex items-center gap-3">
                  <span className="text-2xl">{item.icon}</span>
                  {item.title}
                </h2>
                <div className="text-gray-700 leading-relaxed space-y-3">
                  {item.body}
                </div>
              </section>
            ))}

            {/* Contact CTA */}
            <section className="bg-gradient-to-br from-[#437d6a] to-[#356b5a] rounded-3xl p-10 text-white shadow-xl">
              <h2 className="text-2xl font-bold mb-4">
                Need Help With a Refund?
              </h2>
              <p className="text-white/90 mb-6">
                Our support team is here to help you resolve any order-related
                concerns quickly and fairly.
              </p>
              <div className="space-y-1 text-white/90">
                <p className="font-semibold">Personalised Hat Patches</p>
                <p>Email: support@personalisedhatpatches.com</p>
                <p>Phone: (703) 666-8193</p>
                <p>Live Chat: Available on our website</p>
              </div>
            </section>

            {/* Footer */}
            <p className="text-sm text-gray-500 text-center pt-10 border-t">
              Last updated on 11/20/24
            </p>
          </div>
        </div>
      </div>
    </>
  );
};

export default Refund;
